
$(function () {
  $('[data-submenu-trigger]').each(function (index, item) {
    var triggerEl = $(item);
    triggerEl.on('click', function () {
      var id = triggerEl.attr('data-submenu-trigger');
      var menuEl = $('[data-submenu="' + id + '"]');
      menuIsOpen(menuEl) ? closeSubmenu(menuEl, triggerEl) : openSubmenu(menuEl, triggerEl);
    });
  })
});

function menuIsOpen(menuEl) {
  return menuEl.hasClass('-open');
}

function openSubmenu(menuEl, triggerEl) {
  closeAllOpenSubmenus();
  triggerEl.addClass('-active');
  menuEl.addClass('-open -show');

  menuEl.slideDown({
    duration: 260,
    queue: false
  });

  requestAnimationFrame(function () {
    $(document).on('click.submenu', function (ev) {
      if (!$(ev.target).hasClass('submenu__wrapper') && !$(ev.target).parents('.submenu__wrapper').length) {
        closeSubmenu(menuEl, triggerEl);
      }
    });
  });
}

function closeSubmenu(menuEl, triggerEl) {
  triggerEl.removeClass('-active');
  menuEl.removeClass('-open -show');

  menuEl.slideUp({
    duration: 260,
    queue: false
  });

  $(document).off('click.submenu');
}

function closeAllOpenSubmenus() {
  let selector = '[data-submenu].-open';

  $.each($(selector), function (index, item) {
    const menuEl = $(item);
    const id = menuEl.attr('data-submenu');
    const triggerEl = $('[data-submenu-trigger="' + id + '"]');
    closeSubmenu(menuEl, triggerEl);
  });
}


// import $ from 'jquery';
// import { config } from '../config';
// import { closeUserMenu } from './user-menu';

// // Variables

// var timeouts = {};

// // Domready

// $(function () {
//   $('[data-secondary-menu-trigger]').each(function (index, item) {
//     const triggerEl = $(item);
//     triggerEl.on('click', function () {
//       const id = triggerEl.attr('data-secondary-menu-trigger');
//       const menuEl = $('[data-secondary-menu="' + id + '"]');
//       menuIsOpen(menuEl) ? closeSecondaryMenu(menuEl, triggerEl) : openSecondaryMenu(menuEl, triggerEl);
//     });
//   });
// });

// // Menu functions

// function menuIsOpen(menuEl) {
//   return menuEl.hasClass('-open');
// }

// function openSecondaryMenu(menuEl, triggerEl) {
//   closeUserMenu();
//   closeAllOpenSecondaryMenues();
//   triggerEl.addClass('-active');
//   menuEl.addClass('-open -show');
//   timeouts.closeSecondaryMenuTimeout && clearTimeout(timeouts.closeSecondaryMenuTimeout);
//   requestAnimationFrame(function () {
//     menuEl.addClass('-animate');
//     $(document).on('click.overflowMenu', function (ev) {
//       if (!$(ev.target).hasClass('secondary-nav__link-wrapper') && !$(ev.target).parents('.secondary-nav__link-wrapper').length) {
//         closeSecondaryMenu(menuEl, triggerEl);
//       }
//     });
//   });
// }

// function closeSecondaryMenu(menuEl, triggerEl) {
//   if (!menuEl.hasClass('-open')) {
//     return;
//   }
//   triggerEl.removeClass('-active');
//   menuEl.removeClass('-open -animate');
//   timeouts.closeSecondaryMenuTimeout = setTimeout(function () {
//     menuEl.removeClass('-show');
//   }, config.defaultTransitionSpeed);
//   $(document).off('click.overflowMenu');
// }

// function closeAllOpenSecondaryMenues(scrolling) {
//   let selector = '[data-secondary-menu].-open';
//   if (scrolling) {
//     selector = '[data-secondary-menu]:not([ignore-scroll]).-open';
//   }
//   $.each($(selector), function (index, item) {
//     const menuEl = $(item);
//     const id = menuEl.attr('data-secondary-menu');
//     const triggerEl = $('[data-secondary-menu-trigger="' + id + '"]');
//     closeSecondaryMenu(menuEl, triggerEl);
//   });
// }

// export { closeAllOpenSecondaryMenues }
